__turbopack_context__.v({
  "about": "gACdXa_about",
  "aboutBlock": "gACdXa_aboutBlock",
  "aboutCopy": "gACdXa_aboutCopy",
  "aboutCta": "gACdXa_aboutCta",
  "accent": "gACdXa_accent",
  "band": "gACdXa_band",
  "closing": "gACdXa_closing",
  "closingBanner": "gACdXa_closingBanner",
  "closingEm": "gACdXa_closingEm",
  "devicesImage": "gACdXa_devicesImage",
  "hasMosaic": "gACdXa_hasMosaic",
  "hero": "gACdXa_hero",
  "heroBleed": "gACdXa_heroBleed",
  "heroCopy": "gACdXa_heroCopy",
  "heroDevices": "gACdXa_heroDevices",
  "heroEm": "gACdXa_heroEm",
  "heroLine": "gACdXa_heroLine",
  "heroSub": "gACdXa_heroSub",
  "mosaic": "gACdXa_mosaic",
  "mosaicImage": "gACdXa_mosaicImage",
  "page": "gACdXa_page",
  "testimonialCard": "gACdXa_testimonialCard",
  "testimonials": "gACdXa_testimonials",
  "testimonialsDesktop": "gACdXa_testimonialsDesktop",
  "testimonialsMobile": "gACdXa_testimonialsMobile",
});
